import { fromJS } from 'immutable'
import {
  LEAVE_GENERTION_EDIT_REQUEST,
  LEAVE_GENERTION_EDIT_SUCCESS,
  LEAVE_GENERTION_EDIT_FAILURE,
  LEAVE_GENERTION_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_GENERTION_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_GENERTION_EDIT_SUCCESS:
      return state
        .set('updatedLeaveGenerations', fromJS(action.payload.updatedLeaveGenerations))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case LEAVE_GENERTION_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedLeaveGenerations', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_GENERTION_EDIT_RESET:
      return state
        .delete('updatedLeaveGenerations')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-generation/leave-generation-edit-reducer.js